export default __webpack_public_path__ + "static/media/background_layer.c909abe5.png";